import { AuthenticationInterceptorService } from '@core/services/authentication-interceptor.service';
import { BrowserModule } from "@angular/platform-browser";
import { NgModule, APP_INITIALIZER } from "@angular/core";
import { RouterModule } from "@angular/router";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { ShopModule } from "./shop/shop.module";
import { SharedModule } from "@shared/shared.module";
import { ToastrModule } from "ngx-toastr";
import { rootRouterConfig } from "./app.routes";
// import ngx-translate and the http loader
import {
  NgbDateParserFormatter,
  NgbDatepickerI18n,
  NgbModule,
} from "@ng-bootstrap/ng-bootstrap";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { HttpClient, HTTP_INTERCEPTORS } from "@angular/common/http";
// components
import { AppComponent } from "./app.component";
import { RecaptchaModule } from "ng-recaptcha";

//keyCloak
import { KeycloakAngularModule, KeycloakService } from "keycloak-angular";
import { initializer } from "./utils/app-init";
import { AppService } from "@core/services/app.service";
import { CaptchaService } from "@shared/services/captcha.service";
import { SharedService } from "@core/services/shared.service";
import { NotifierModule } from "angular-notifier";
import { GlobalHandlerService } from "@core/services/global-handler.service";
import { CNotificationModule } from "@shared/features/c-notification/c-notification.module";
import { notifierOptions } from "@shared/heplers/const-data";
// import { VirtualScrollerModule } from "ngx-virtual-scroller";
import {
  LocationStrategy,
  Location,
  PathLocationStrategy,
} from "@angular/common";
import {
  DatePickerDataFormatterService,
  CustomDatepickerI18n,
} from "@shared/services/date-picker-data-formatter.service";
import { environment } from 'src/environments/environment';
import { FuseMainModule } from './main/main.module';
import { ClipboardService } from '@core/services/clipoard.service';
import { ServiceWorkerModule, SwRegistrationOptions } from '@angular/service-worker';
import { GtmService } from '@shared/services/gtm.service';
import { CookiePreferenceService } from '@core/services/cookie.service';

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return(new TranslateHttpLoader(http, "./assets/i18n/", ".json?cb=" + environment.cb));
}


